import { Portal } from "@ariakit/react";
import { useEffect, useRef, useState } from "react";
import {
  TableOfContents,
  generateTableOfContents,
  type TOCItem,
} from "./table-of-contents";

export function MDXPageWithToc({
  children,
  language,
  id,
}: {
  id: string;
  children: React.ReactNode;
  language: string;
}) {
  const mdxContentRef = useRef<HTMLDivElement>(null);
  const [toc, setToc] = useState<TOCItem[] | null>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: We want to run this effect whenever the language changes
  useEffect(() => {
    if (!mdxContentRef.current) return;

    const headings = mdxContentRef.current.querySelectorAll(
      "h1, h2, h3, h4, h5, h6"
    ) as NodeListOf<HTMLHeadingElement>;

    if (headings.length === 0) {
      setToc(null);
      return;
    }

    const toc = generateTableOfContents(headings);

    setToc(toc);
  }, [language]);

  return (
    <div className="mdx-content-wrap relative">
      {toc && (
        <Portal
          portalElement={document.querySelector<HTMLElement>(
            `[data-toc="${id}"]`
          )}
        >
          <TableOfContents items={toc} />
        </Portal>
      )}
      <div ref={mdxContentRef} className="mdx-content">
        {children}
      </div>
    </div>
  );
}
